import {useCallback, useState} from 'react';
import {useDispatch} from 'react-redux';
import {ExitPremiumPreviewModal} from '~/common/FabricInvitation/EventCreateDesign/components/ExitPremiumPreviewModal/ExitPremiumPreviewModal';
import {useNavigator} from '~/common/FabricInvitation/EventCreateDesign/components/NavBottom/hooks/useNavigator';
import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {REVERT_TO_BASIC} from '~/common/fabric/reducers/fabricDesign/constants';

export const useExitPreviewModal = () => {
  const [showExitPremiumPreviewModal, setShowExitPremiumPreviewModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigator({});

  const showExitPreviewModal = useCallback(() => setShowExitPremiumPreviewModal(true), []);
  const closeExitPremiumPreviewModal = useCallback(() => setShowExitPremiumPreviewModal(false), []);

  const confirmExitPremiumPreviewModal = useCallback(() => {
    dispatch({type: REVERT_TO_BASIC});
    navigate(Sections.CARD_DESIGN);
    setShowExitPremiumPreviewModal(false);
  }, [dispatch, navigate]);

  const renderExitPremiumPreviewModal = showExitPremiumPreviewModal ? (
    <ExitPremiumPreviewModal
      closeOverlay={closeExitPremiumPreviewModal}
      onConfirmAction={confirmExitPremiumPreviewModal}
    />
  ) : null;

  return {
    showExitPremiumPreviewModal,
    showExitPreviewModal,
    closeExitPremiumPreviewModal,
    confirmExitPremiumPreviewModal,
    renderExitPremiumPreviewModal,
  };
};
